module.exports = __webpack_public_path__ + "static/media/IMG_0358.d05c1326.jpg";